var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightFromBracketSolidFull1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512.051,
    height: 448,
    viewBox: "0 0 512.051 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "right-from-bracket-solid-full",
    className: "cls-1",
    d: "M569,337a23.9,23.9,0,0,0,0-33.9L425,159a24.015,24.015,0,0,0-41,17v80H272a48.012,48.012,0,0,0-48,48v32a48.012,48.012,0,0,0,48,48H384v80a24.015,24.015,0,0,0,41,17ZM224,160a32,32,0,0,0,0-64H160a96.025,96.025,0,0,0-96,96V448a96.025,96.025,0,0,0,96,96h64a32,32,0,0,0,0-64H160a31.966,31.966,0,0,1-32-32V192a31.966,31.966,0,0,1,32-32Z",
    transform: "translate(-64 -96)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFromBracketSolidFull1);
export default __webpack_public_path__ + "static/media/right-from-bracket-solid-full (1).3f8529f92f1987d3fb60e120e7b0b642.svg";
export { ForwardRef as ReactComponent };